export default "__VITE_ASSET__B3S6rA2g__"